<template>
  <l-modal :showing="showing" :text="'Change password for ' + user.username" icon="edit" color="bg-orange-500" @close="close">
    <div class="w-full text-xs" v-if="user.username">
      <div class="w-full flex mb-4">
        <l-input placeholder="Create new password" v-model="password" type="password" ></l-input>
      </div>
     
      <div class="flex w-full justify-between">
        <l-button type="success" @click="onSave">Save changes</l-button>
        <l-button type="danger" @click="close">Cancel</l-button>
      </div>
    </div>
  </l-modal>
</template>

<script>
import LModal from "@/components/LModal";
import { LInput, LButton } from "@/components/forms";

export default {
  name: "LLEdit",
  props: ["showing", "user"],
  components: {
    LModal,
    LInput,
    LButton
  },
  data() {
    return {
      password: ""
    };
  },
  methods: {
    close() {
      this.password = "";
      this.$emit("close");
    },
    onSave() {
      this.$emit("save", {
        username: this.user.username,
        password: this.password
      });
      this.password = "";
      this.close();
    }
  }
};
</script>